"use client";

import { Switch } from "@headlessui/react";
import cx from "classnames";

export default function Toggle({
    value,
    onChange,
    leftLabel,
    rightLabel,
    isDisabled,
    isError,
}) {
    return (
        <Switch.Group as="div" className="flex items-center w-full">
            {!!leftLabel && (
                <Switch.Label
                    as="span"
                    className="mr-3 text-sm select-none flex-1 text-lato">
                    {leftLabel}
                </Switch.Label>
            )}
            <Switch
                checked={value}
                onChange={isDisabled ? undefined : onChange}
                className={cx(
                    value ? "bg-primary-100" : "bg-primary-10",
                    "relative inline-flex h-8 w-14 items-center flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-100 focus:ring-offset-2",
                )}>
                <span
                    aria-hidden="true"
                    className={cx(
                        value ? "translate-x-6" : "translate-x-0",
                        "pointer-events-none inline-block h-6 w-6 m-0.5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
                    )}
                />
            </Switch>
            {!!rightLabel && (
                <Switch.Label
                    as="span"
                    className="ml-3 text-sm select-none flex-1 text-lato">
                    {typeof rightLabel === "string" ? (
                        <span className="text-base">{rightLabel}</span>
                    ) : (
                        rightLabel
                    )}
                </Switch.Label>
            )}
        </Switch.Group>
    );
}
